export enum TaxonomySource {
  EXTERNAL = 'external',
  MANUAL = 'manual',
}
